<template>
    <div class="page">
        <div class="top">
            <div class="top-back" @click="backGo">
                <img src="@/assets/newUser/12.png" alt="">
            </div>
            <div class="top-name">余额充值</div>
        </div>
        <div class="text">定额充值</div>
        <div class="money-list-flex">
            <div class="money-items " :class="{ 'active': currentItem === index }" v-for="(item, index) in packageChoose"
                :key="index" @click="changeState(index, item[0], item[1])">
                <div class="items">
                    <div class="text2">{{ item[0] }}</div>
                    <div class="text3">元</div>
                </div>
                <div class="total-price">到账 <span>{{ item[1] }}</span></div>
            </div>
        </div>
        <!-- <div class="text7">其他金额</div>
        <div class="money-other">
            <van-field v-model="definedPrice" type="numer" class="ph-t" clearable placeholder="请输入其他金额" />
        </div> -->
        <div class="btn" @click="btnActionRecharge()">确认充值</div>
        <!-- 密码框   -->
        <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
        <div class="van-popup van-popup--round van-popup--center changePasswordPanel-balanceRecharge"
            style="z-index: 2000; min-height: 25%; min-width: 80%;" v-show="showPasswordPanel"
            :style="{ top: passwordPanelTop + '%' }">
            <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()" />
            <!-- 密码输入框 -->
            <p>设置支付密码：</p>
            <van-password-input :value="password" :focused="passwordKeyboard" @focus="passwordOnfocus()" />
            <!-- 再次确认密码输入框 -->
            <p>再次确认密码：</p>
            <van-password-input :value="confirmPassword" :focused="confirmPasswordKeyboard"
                @focus="confirmPasswordOnfocus()" />
            <div class="confirmChangePassword">
                <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToRecharge()">确 定</van-button>
            </div>
        </div>
        <!-- 数字键盘 -->
        <van-number-keyboard :z-index="2015" :show="passwordKeyboard" @input="passwordOnInput" @delete="passwordOnDelete"
            @blur="passwordKeyboard = false" />
        <van-number-keyboard :z-index="2015" :show="confirmPasswordKeyboard" @input="confirmPasswordOnInput"
            @delete="confirmPasswordOnDelete" @blur="confirmPasswordKeyboard = false" />
        <!-- 数字键盘 end -->
        <!-- 密码框 end  -->
        <Checkstand :checkstandStyle="checkstandStyle" :dataToPay="dataToPay" :price="price" />

        <br />
        <br />
        <div class="balanceRecharge-tip">
            <p><span>温馨提醒</span></p>
            <p>1、可使用余额来进行购买套餐</p>
            <p>2、充值余额后，系统将会自动使用余额续费套餐</p>
            <p>3、请确保余额充足，避免自动续费失败</p>
        </div>


    </div>
</template>
<script>
import { Toast } from 'vant';
import { wxRequest } from '@/api/user'
import Checkstand from "@/components/Checkstand";
export default {
    components: {
        Checkstand
    },
    data() {
        return {
            definedPrice: '',
            currentItem: 0,
            packageChoose: [],
            price: 0,
            giftBalance: 0,
            type: '',
            showPasswordPanel: false,
            password: '',
            confirmPassword: "",
            passwordKeyboard: false,
            confirmPasswordKeyboard: false,
            passwordPanelTop: 50,
            alreadySetUp: false,
            dataToPay: {},
            checkstandStyle: {
                height: '50%',
                transition: '0.8s !important',
            },
            mobile: ''
        }
    },
    watch: {
        definedPrice: {
            handler(val) {
                if (val) {
                    this.currentItem = null
                }
            },
            deep: true,
            immediate: true
        },
    },
    created() {
        this.init()
    },
    methods: {
        backGo() {
            this.$router.replace("/newUser/home");
        },
        init() {
            wxRequest("/sim/uniorder/param", { iccid: localStorage.getItem('iccid') }, "post").then(res => {
                if (res.data.code == 200) {
                    for (let i = 0; i < res.data.data.length; i++) {
                        let itme = [res.data.data[i].amount, res.data.data[i].amount + res.data.data[i].giftBalance];
                        this.packageChoose.push(itme);
                    }
                    this.price = this.packageChoose[0][0];
                    this.giftBalance = (this.packageChoose[0][1] - this.packageChoose[0][0]) * 100;
                } else {
                    Toast.fail(res.data.message);
                }
            })
            let param = {
                iccid: this.$store.state.iccid,
                mobile: localStorage.getItem('mobile'),
            }
            wxRequest("/sysUser/account/querySysUserAccount", param, "post").then(res => {
                if (res.data.code == 200) {
                    this.alreadySetUp = true;
                    this.mobile = res.data.data.mobile;
                }
            });
        },
        //输入完密码后点击 【确定】 时
        sureToRecharge() {
            if (this.checkPassword()) {
                if (this.type == "recharge") {
                    this.toRecharge();
                } else if (this.type == "rechargeDefined") {
                    this.toRechargeDefined();
                }
            }
        },
        changeState(currentItem, price, giftBalance) {
            this.currentItem = currentItem;
            this.price = price;
            this.type == "recharge"
            this.giftBalance = (giftBalance - price) * 100;
        },
        btnActionRecharge() {
            this.type = "recharge";
            //若当前为自定义状态
            if (this.currentItem === null) {
                this.type = "rechargeDefined"
            }
            // if(this.alreadySetUp){
            //     this.sureToRecharge();
            // }else{
            //     this.showPasswordPanel = true;
            // }
            this.toRecharge();
        },
        toRecharge() {
            var data = {
                iccid: this.$store.state.iccid,
                amount: this.price * 100,
                giftBalance: this.giftBalance,
                //  payPass: this.confirmPassword,
                payPass: '000000',
                mobile: this.mobile
            }

            this.$store.state.showCheckstandSource = 'balanceRecharge';
            this.dataToPay = data;
            this.$store.state.showCheckstand = true;
            this.cancelChangePassword();
        },
        toRechargeDefined() {
            var data = {
                iccid: this.$store.state.iccid,
                amount: (this.definedPrice * 100).toFixed(0),
                giftBalance: this.giftBalance,
                // payPass: this.confirmPassword,
                payPass: '000000',
                mobile: this.mobile
            }
            this.$store.state.showCheckstandSource = 'balanceRecharge';
            this.dataToPay = data;
            this.$store.state.showCheckstand = true;
            this.price = this.definedPrice;
            this.definedPrice = '';
            this.cancelChangePassword();
        },
        /***   修改密码     ***/
        passwordOnfocus() {
            this.passwordKeyboard = true;
            this.confirmPasswordKeyboard = false;
            this.passwordPanelTop = 30;
        },
        passwordOnDelete() {
            this.password = this.password.slice(0, this.password.length - 1);
        },

        passwordOnInput(key) {
            this.password = (this.password + key).slice(0, 6);
        },


        confirmPasswordOnfocus() {
            this.passwordKeyboard = false;
            this.confirmPasswordKeyboard = true;
            this.passwordPanelTop = 30;
        },
        confirmPasswordOnDelete() {
            this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
        },

        confirmPasswordOnInput(key) {
            this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
        },


        cancelChangePassword() {
            this.password = '';
            this.confirmPassword = '';
            this.passwordPanelTop = 50;
            this.showPasswordPanel = false;
        },

        checkPassword() {
            if (this.alreadySetUp) {
                return true;
            }
            if (this.password.length < 6) {
                Toast.fail("请设置六位支付密码");
                return false;
            }

            if (this.password != this.confirmPassword) {
                Toast.fail("两次输入的密码不一致");
                return false;
            }
            return true;
        },
    }
}
</script>
<style lang="less" scoped>
div {
    display: flex;
    flex-grow: 0;
    flex-basis: auto;
    align-items: stretch;
    flex-direction: column;
}

.page {
    height: 100%;
    background: #f7f8fa;

    .top {
        flex-direction: row;
        align-items: center;
        height: 60px;
        background-color: #ffffff;

        .top-back {
            width: 60px;
            align-items: center;
            text-align: center;
            position: absolute;
            height: 60px;
            line-height: 60px;
            z-index: 999;
            justify-content: center;

            img {
                width: 20px;
                height: 20px;
            }
        }

        .top-name {
            text-align: center;
            font-size: 17px;
            color: #06121e;
            flex: 1 1 0%;
            font-weight: bold;
        }
    }

    .text {
        font-size: 16px;
        color: #06121e;
        margin-top: 16px;
        width: 340px;
        align-self: center;
    }

    .money-list-flex {
        width: 90%;
        align-self: center;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 14px;

        .money-items {
            align-items: center;
            width: 31%;
            flex-shrink: 0;
            border: 1px solid rgba(52, 118, 254, .1);
            border-radius: 4px;
            padding: 20px 0 20px;
            margin-bottom: 14px;

            .items {
                flex-direction: row;
                justify-content: center;
                align-items: flex-end;

                .text2 {
                    font-size: 26px;
                    color: #3476fe;
                    font-weight: 500;
                    line-height: 23px;
                }

                .text3 {
                    font-size: 14px;
                    color: #3476fe;
                    font-weight: 500;
                }
            }
            .total-price{
                margin-top:10px;
                font-family: PingFangSC-Regular, PingFang SC;
                flex-direction: row;
                span{
                    color:#FB694A;
                    font-weight:bold;
                    padding-left:4px;
                }
            }
        }

        .active {
            background-color: rgba(52, 118, 254, .1);
        }
    }

    .text7 {
        width: 90%;
        align-self: center;
        font-size: 16px;
        color: #8c9198;
    }

    .balanceRecharge-tip {
        padding: 10px 20px 10px 20px;

        p {
            span {
                color: #FFA941;
            }

            line-height: 20px;
        }
    }

    .money-other {
        width: 90%;
        background: none;
        align-self: center;
        height: 40px;
        border-bottom: 1px solid #eee;
        justify-content: center;
        margin-top: 13px;

        .van-cell {
            background: none;
            font-size: 16px;
            color: #808080;
            padding-left: 0;
        }
    }

    .btn {
        width: 200px;
        height: 47px;
        border-radius: 94px;
        font-size: 16px;
        line-height: 47px;
        margin-top: 66px;
        align-self: center;
        border: 0;
        background: #3476fe;
        color: #fff;
        text-align: center;
    }
}
</style>
<style lang="less">
#balanceRecharge .checkstand-defined-popup .van-field__control {
    font-size: 24px;
}

#balanceRecharge .checkstand-defined-popup input::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    font-size: 14px;
}

#balanceRecharge .checkstand-defined-popup input::-moz-placeholder {
    /* Firefox 19+ */
    font-size: 14px;
}

#balanceRecharge .checkstand-defined-popup input::-ms-input-placeholder {
    /* IE 10+ */
    font-size: 14px;
}

#balanceRecharge .checkstand-defined-popup input::-moz-placeholder {
    /* Firefox 18- */
    font-size: 14px;
}

#balanceRecharge .passwordInput .van-field__control {
    height: 24px;
}

.changePasswordPanel-balanceRecharge [class*=van-hairline]::after {
    border-color: #c4cedc;
}

.changePasswordPanel-balanceRecharge {
    padding: 10px;

    .icon-cross {
        position: absolute;
        right: 10px;
        font-size: 16px;
    }

    p {
        margin: 10px 16px 0 16px;
        line-height: 30px;
    }

    .confirmChangePassword {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
        flex-direction: row;

        .confirmChangePasswordBtn {
            width: 80px;
            margin: 0 15px;
        }
    }
}</style>

